/* template */
<template><div class="service-desc-bar-container"><div class="service-name"><div class="name">{{serviceName}}</div><spring-icon size="20" color="#999" name="circle-question-mark" @click="openRightsDescDrawer" :externClass='["question-mark"].join(" ")'/></div><div class="service-status">已开启</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"mb0598286"}'>
  .service-desc-bar-container
    background #fff
    margin-top 8px
    border-radius 8px
    padding 16px
    padding-right 14px
    box-sizing border-box
    line-height 16px
    display flex
    justify-content space-between
    align-items center
    .service-name
      display flex
      align-items center
      .name
        font-size 16px
        font-family PingFangSC-Semibold
        font-weight 600
        color #333
      .question-mark
        margin-left 4px
    .service-status
      font-size 14px
      line-height 14px
      font-family PingFangSC-Regular
      font-weight 400
      color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mb0598286"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./service-desc-bar.mpx.js?isComponent&outputPath=components%2Fservice-desc-barb0598286%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./service-desc-bar.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fservice-desc-barb0598286%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mb0598286"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/service-desc-barb0598286/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'spring-icon':getComponent(require("../../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
